import { DescriptionField, DescriptionList } from "@dash/description-list";
import { HeaderBar } from "@dash/page";
import { Spinner } from "@dash/spinner";
import React, { useEffect } from "react";

import { useClientManager } from "@megaron/react-clients";

import { useBeep } from "./beep";
import { QrScanner } from "./QrScanner";
import { ScanStatusCard } from "./ScanStatusCard";

export const UngroupCodeView: React.FC = () => {
  const beep = useBeep();

  const [scannedCodes, setScannedCodes] = React.useState<string[]>([]);
  const [lastScannedCode, setLastScannedCode] = React.useState<string | undefined>();

  const groupsQuery = useClientManager("loyaltyPoints")
    .codeGroupsQuery()
    .useQuery(
      { codeId: lastScannedCode!, type: ["pokrywki", "produkcja_pokrywki"] },
      { enabled: !!lastScannedCode },
    );

  const onScan = (code: string) => {
    setLastScannedCode(code);
    setScannedCodes((prev) => (prev.includes(code) ? prev : [...prev, code]));
  };

  useEffect(() => {
    if (lastScannedCode) {
      (async () => {
        await beep(800);
      })();
    }
  }, [lastScannedCode]);

  return (
    <div>
      <HeaderBar header="Usuń kody" actions={<></>} />
      <div style={{ display: "none" }}>
        {scannedCodes
          .filter((code) => code !== lastScannedCode)
          .map((code) => (
            <UngroupCodeProcessor key={code} codeId={code} />
          ))}
      </div>
      <QrScanner onScan={onScan}>
        {lastScannedCode && (
          <div css={{ position: "absolute", top: "50px", width: "100%", padding: "1rem" }}>
            <ScanStatusCard code={lastScannedCode} error={undefined}>
              <DescriptionList>
                {groupsQuery.data?.map((group) => (
                  <UngroupCodeField
                    codeId={lastScannedCode}
                    groupName={group.name}
                    key={lastScannedCode + group.name}
                  />
                ))}
              </DescriptionList>
            </ScanStatusCard>
          </div>
        )}
      </QrScanner>
    </div>
  );
};

const UngroupCodeProcessor: React.FC<{ codeId: string }> = ({ codeId }) => {
  const groupsQuery = useClientManager("loyaltyPoints")
    .codeGroupsQuery()
    .useQuery({ codeId, type: ["pokrywki", "produkcja_pokrywki"] });

  return (
    groupsQuery.data?.map((group) => (
      <UngroupCodeField codeId={codeId} groupName={group.name} key={codeId + group.name} />
    )) ?? null
  );
};

export const UngroupCodeField: React.FunctionComponent<{
  groupName: string;
  codeId: string;
}> = (props) => {
  const beep = useBeep();

  const ungroupMutation = useClientManager("loyaltyPoints")
    .removeCodesFromGroup()
    .useMutation({
      onSuccess: async () => {
        await beep(1200);
      },
    });

  useEffect(() => {
    ungroupMutation.mutate({ codeIds: [props.codeId], groupName: props.groupName });
  }, [props.codeId, props.groupName]);

  return (
    <DescriptionField
      label={
        <div css={{ display: "flex", flexDirection: "row", gap: "0.5rem" }}>
          Grupa
          {ungroupMutation.isLoading && <Spinner color="white" />}
        </div>
      }
      color="white"
    >
      <span css={{ textDecoration: ungroupMutation.isSuccess ? "line-through" : undefined }}>{props.groupName}</span>
    </DescriptionField>
  );
};
